module.exports = __webpack_public_path__ + "img/rzlogo.a663300e.svg";